/** Shared app time formatting — always includes seconds unless opted out. */

export const pad2 = (value) => String(value).padStart(2, "0");

export const getLiveTimeParts = (date, use12Hour = false) => {
  const d = date instanceof Date ? date : new Date(date);
  const hours = d.getHours();
  const minutes = d.getMinutes();
  const seconds = d.getSeconds();
  return {
    hours24: pad2(hours),
    minutes: pad2(minutes),
    seconds: pad2(seconds),
    hours12: String(hours % 12 || 12),
    meridiem: hours >= 12 ? "PM" : "AM",
    display24: `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`,
    display12: `${hours % 12 || 12}:${pad2(minutes)}:${pad2(seconds)}`,
    use12Hour,
  };
};

export const formatAppTime = (value, options = {}) => {
  const { use12Hour = false, includeSeconds = true } = options;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";

  const parts = getLiveTimeParts(d, use12Hour);
  if (use12Hour) {
    const base = `${parts.hours12}:${parts.minutes}`;
    return includeSeconds
      ? `${base}:${parts.seconds} ${parts.meridiem}`
      : `${base} ${parts.meridiem}`;
  }
  const base = `${parts.hours24}:${parts.minutes}`;
  return includeSeconds ? `${base}:${parts.seconds}` : base;
};

export const formatAppDate = (value, options = {}) => {
  const { includeWeekday = true, includeYear = true } = options;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";

  return d.toLocaleDateString(undefined, {
    ...(includeWeekday ? { weekday: "long" } : {}),
    month: "long",
    day: "numeric",
    ...(includeYear ? { year: "numeric" } : {}),
  });
};

export const formatAppDateTime = (value, options = {}) => {
  const {
    use12Hour = false,
    includeSeconds = true,
    includeWeekday = true,
    includeYear = true,
  } = options;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";

  const datePart = formatAppDate(d, { includeWeekday, includeYear });
  return `${datePart} · ${formatAppTime(d, { use12Hour, includeSeconds })}`;
};

export const prefers12HourClock = () => {
  try {
    const sample = new Date(2020, 0, 1, 13, 0, 0);
    return /\b(am|pm)\b/i.test(
      sample.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })
    );
  } catch {
    return false;
  }
};
